import * as React from 'react';

import EditIcon from '@mui/icons-material/BorderColorOutlined';
import { Grid, IconButton, TextField } from "@mui/material";
import RecordList from "../components/RecordList";
import { ReactComponent as TemplatedTopicSaveIcon }from './icons/save_icon.svg'
import DeleteIconButton from '../components/DeleteIconButton';
import { useSnackbar } from 'notistack';
import { DataAPIContext, UPDATE } from '../api';
import { NavigateBefore } from "@mui/icons-material";
import Autocomplete from '@mui/material/Autocomplete';
import { ContextStore } from '../store/contextStore';
import { cv } from '../themeVars';

export default function TemplatedMessageTopicsMenu(props) {
    const [topicsMenuAPIFilters, setTopicsMenuAPIFilters] = React.useState([]);
    const [isEditingTopic, setIsEditingTopic] = React.useState(false);
    const [topicBeingEdited, setTopicBeingEdited] = React.useState(null);
    const [topicEditingName, setTopicEditingName] = React.useState(null);
    const [topicInputValue, setTopicInputValue] = React.useState("");
    const templateTopicRef = React.useRef(null);
    const topicTitleFieldRef = React.useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const dataAPI = React.useContext(DataAPIContext);
    const { hasPerm } = React.useContext(ContextStore);
    const canWriteTemplates = hasPerm('chat_template', 'write');
    const templated_topics_list_resource = "templated_chat_message_topics";

    
    const handleTemplatedMsgTopicSave = (ev) => {
        const topicTitle = topicTitleFieldRef.current.value;

        if (!topicTitle || !topicTitle.trim()) {
            enqueueSnackbar("Templated message topic validation error", { variant: 'warning' });
            return
        }

        (async () => {
            try {
                const res = await dataAPI(UPDATE, templated_topics_list_resource, {
                    id: topicBeingEdited.id,
                    data: {
                        topic_name: topicTitle,
                    }
                });

                if (res.statusCode === 200 || res.statusCode === 201) {
                    props.updateTemplatedMsgRefreshKey()
                    enqueueSnackbar("Templated message topic saved", { variant: 'success' });
                    setTopicBeingEdited(null)
                    setIsEditingTopic(false);
                } else if (res.statusCode === 406) {
                    enqueueSnackbar("Templated message topic validation error", { variant: 'warning' });
                    //setServerErrors(res.data.errors);
                }
                else {
                    enqueueSnackbar("Error saving templated message topic", { variant: 'error' });
                }
            } finally {
            }
        })();
    }


    const onMenuTopicChange = (ev, topic, reason) => {
        console.log('onMenuTopicChange: topic change', topic);
        templateTopicRef.current = topic?.name || topic?.title;
        props.setState((prevState) => ({ ...prevState, templatedMessageTopic: templateTopicRef.current || prevState.templatedMessageTopic}));
        const dict = topic?.id != null ? { field: 'id', op: 'equals', value: String(topic.id) } : topic ? { field: 'topic', op: 'null'} : null
        if(dict){
            setTopicsMenuAPIFilters([
                dict
            ]);
        }
        else{
            setTopicsMenuAPIFilters([])
        }
    };

    React.useEffect(() => {
        props.populateTopics();
    }, [props.templatedMsgRefreshKey]);


    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>

            <span style={{ paddingTop: "8px", zIndex: 12, marginBottom: 9 }}>
                <NavigateBefore style={{ cursor: "pointer", position: "absolute", paddingBottom: 2 }} onClick={(e) => { e.stopPropagation(); props.handleGoBack() }} />&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;
                <b>
                    <span style={{ position: "absolute", right: 0, marginTop: 0, fontSize: ".01rem", color: cv('surface', "white") }}>★</span>
                    Template topics
                </b>
                <span onClick={e => props.closeTemplatedMessagesPane()} style={props.styles.closeButton}>&times;</span>
            </span>
            <span style={{ position: "absolute", left: 0, top: 0, height: "50px", width: "100%", backgroundColor: cv('surface-muted', "#F5F5F5"), borderRadius: "15px 15px 0px 0px" }}></span>

            <Grid container direction="row" style={{ color: "#F5F5F5", marginBottom: "7px" }}>
                <Grid item xs={12} style={{ padding: "10px" }}>
                    <Autocomplete
                        options={props.topicOptions}
                        value={templateTopicRef.current ? { "name": templateTopicRef.current } : null}
                        noOptionsText={topicInputValue.trim() && props.topicOptions.findIndex((o) => o.name.toUpperCase() === topicInputValue.trim().toUpperCase()) === -1 ? `Press Enter to add "${topicInputValue}"` : null}
                        getOptionLabel={(option) => option.title || option.name}
                        onInputChange={(e, newValue) => {
                            setTopicInputValue(newValue.trim());
                        }}
                        onChange={onMenuTopicChange}
                        freeSolo
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={topicInputValue.trim() && props.topicOptions.findIndex((o) => o.name.toUpperCase() === topicInputValue.toUpperCase()) === -1 ? `Pressing Enter will add \"${topicInputValue}\"` : "Type to search or add a topic"}
                                variant="filled"
                                size="small"
                                //helperText="Enter to add new"
                                onKeyDown={(e) => {
                                    if (
                                        e.key === "Enter" && topicInputValue.trim() &&
                                        props.topicOptions.findIndex((o) => o.name.toUpperCase() === topicInputValue.trim().toUpperCase()) === -1
                                    ) {
                                        props.setTopicOptions((o) => o.concat({ name: topicInputValue }));
                                        templateTopicRef.current = topicInputValue;
                                        props.setState((prevState) => ({ ...prevState, templatedMessageTopic: templateTopicRef.current || prevState.templatedMessageTopic }));
                                        props.handleTemplatedMsgTopicSave(topicInputValue)
                                    }
                                    else if (e.key == 'ArrowDown' || e.key == 'ArrowUp'){
                                        e.stopPropagation()
                                    }
                                }}
                            />
                        )}
                    />
                </Grid>
            </Grid>
            <RecordList
                resource={templated_topics_list_resource}
                perPage={100}
                rowHeight={80}
                headerHeight={0}
                checkboxSelection={false}
                //refreshFromBackendFunc={refreshFromBackendFunc}
                hideQuickFilter={true}
                disableSelectionOnClick={true}
                query={topicInputValue}
                apiFilters={topicsMenuAPIFilters}
                hiddenAPIFilters={props.templatedMsgRefreshKey}
                minHeight={"calc(86vh - 170px)"}
                maxHeight={"calc(86vh - 170px)"}
                headerDisplay={"none"}
                rowsPerPageOptions={[]}
                columns={[
                    {
                        field: 'title', headerName: 'Title', sortable: false, flex: 5.00,
                        renderCell: (p) => {
                            return (
                                <span style={{ display: "flex", width: "98%", marginTop: "6px", marginLeft: "6px" }} onClick={(e) => { e.stopPropagation() }}>
                                    <span title={p.row.name} style={{ flex: 5, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginRight: "20px", verticalAlign: "middle", marginTop: "auto", marginBottom: "auto" }}>
                                        {!isEditingTopic || topicBeingEdited !== p.row ? <span style={{ marginTop: "50%" }}>{p.row.name && <b>{p.row.name} ({p.row.num_associated_templated_messages})</b>}</span>
                                            : <TextField
                                                variant="filled"
                                                hiddenLabel
                                                size="small"
                                                defaultValue={p.row.name}
                                                inputRef={topicTitleFieldRef}
                                                onChange={(e) => { setTopicEditingName(topicTitleFieldRef.current?.value) }}
                                                onClick={(e) => {
                                                    e.stopPropagation();

                                                }} />}
                                    </span>
                                    {p.row.id &&
                                        <span style={{ verticalAlign: "middle", flex: 1, marginTop: "auto", marginBottom: "auto", marginLeft: "auto" }}>
                                            {canWriteTemplates && (!isEditingTopic || topicBeingEdited !== p.row ?
                                                < IconButton onClick={(e) => {
                                                    e.stopPropagation();
                                                    setTopicBeingEdited(p.row)
                                                    setIsEditingTopic(true);
                                                }}>
                                                    <EditIcon style={{ color: cv('accent', '#007AFF') }} />
                                                </IconButton>
                                                :
                                                <IconButton
                                                    disabled={topicEditingName === "" || topicEditingName === p.row.name}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleTemplatedMsgTopicSave();
                                                    }}>

                                                    <TemplatedTopicSaveIcon fill={topicEditingName != "" && topicEditingName != p.row.name ? "#007AFF" : "rgba(0, 0, 0, 0.26)"} />
                                                </IconButton>)
                                            }
                                            <DeleteIconButton
                                                perm="chat_template.delete"
                                                size="medium"
                                                fontSize="medium"
                                                disabled={isEditingTopic && topicBeingEdited === p.row}
                                                onClick={(e) => { e.stopPropagation(); props.handleDeleteTemplatedMsgTopic(p.row.id, p.row.num_associated_templated_messages) }}
                                            />
                                        </span>
                                    }
                                </span>
                            );
                        },
                    },
                ]
                }
            />
        </div>
    );
}
